<template>
  <div
    v-if="loadingRoles"
    style="width: 370px"
  >
    <Loader />
  </div>
  <EditableList
    v-else
    ref="list"
    :list="rolesList"
    :pending="pending"
    hide-remove
    hide-add
    :form-add-title="$t('settings.roles.add')"
    :form-edit-title="$t('settings.roles.edit')"
    @submit="$refs.form.submit()"
    @remove="$refs.form.remove()"
  >
    <template #listElement="{ row }">
      <span class="text-truncate">
        {{ row.email }}
      </span>
    </template>

    <template #submit="{edited}">
      <div>
        <button
          class="btn btn-sm btn-secondary"
          type="button"
          @click="$emit('show-edit', getUser(edited))"
        >
          <i class="fas fa-pen pr-2" />
          {{ $t('general.edit') }}
        </button>
      </div>
    </template>

    <template #form="{edited}">
      <RoleForm
        ref="form"
        :pending.sync="pending"
        :tenant-id="payee.ownerId"
        :user="getUser(edited)"
        @close="$refs.list.close()"
      />
    </template>
  </EditableList>
</template>

<script>
import EditableList from '@/components/settings/EditableList';
import { mapGetters } from 'vuex';
import RoleForm from './RoleForm';

export default {
  props: {
    roles: Array,
  },
  data: () => ({
    newGroup: null,
    selected: null,
    pending: false,
    loadingRoles: false,
  }),
  components: {
    RoleForm,
    EditableList,
  },
  computed: {
    ...mapGetters(['payee', 'roleTypes']),
    rolesList() {
      if (!this.roles) return [];
      return Object.entries(this.roles
        .reduce((acc, curr) => {
          const scopeParts = String(curr.scope || '').split('|').filter(Boolean);
          const isListingScope = scopeParts.length > 2;
          if (isListingScope) {
            return acc;
          }

          if (acc[curr.userId]) {
            acc[curr.userId].push(curr);
          } else {
            acc[curr.userId] = [curr];
          }
          return acc;
        }, {}))
        .map(([key, value]) => ({
          id: key,
          email: value[0].email,
          list: value,
        }))
        .filter((x) => x.list.length > 0);
    },
  },
  methods: {
    getUser(id) {
      return this.rolesList.find((x) => x.id === id);
    },
  },
  created() {
    this.$emit('page', 'userGroups');
  },
};
</script>
